module.exports = __webpack_public_path__ + "media/preview/all_hands@3x-4b5ef9f5.png";